<button (click)="textToClipboard(contentCopy)"><img src="../../../assets/img/copy-b-icon.svg" alt=""></button>
